declare namespace $ {

	export class $bog_LocalScript_button extends $mol_button_major {
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map